import { RequestReliability } from '@savgroup-front-common/types';

import globalMessages from '../helpers/i18n';

export const getSparePartRequestReliabilityMessage = (
  reliability: RequestReliability,
) => {
  if (reliability === RequestReliability.RELIABLE) {
    return globalMessages.sparePartRequestReliabilityMessages.reliable;
  }

  if (reliability === RequestReliability.TO_CHECK) {
    return globalMessages.sparePartRequestReliabilityMessages.toCheck;
  }

  if (reliability === RequestReliability.TO_REFERENCE) {
    return globalMessages.sparePartRequestReliabilityMessages.toReference;
  }

  return undefined;
};
